/* @flow */
import React from "react";

import InputRange from "react-input-range";

type Props = {
    value: null | boolean;
    disabled: boolean;
    onChange?: (x0: null | boolean) => void;
};

export class ThreeStateToggle extends React.Component<Props> {
    static defaultProps = {
        value: null,
        disabled: false
    };

    handleChange = (newValue: number) => {
        if (this.props.onChange) {
            if (newValue === 1) {
                this.props.onChange(null);
            } else {
                this.props.onChange(newValue > 1);
            }
        }
    };

    render() {
        let value;
        if (this.props.value === true) {
            value = 2;
        } else if (this.props.value === false) {
            value = 0;
        } else {
            value = 1;
        }
        return (
            <div className={"input-range-boolean input-range-boolean-value-" + value}>
                <InputRange
                    minValue={0}
                    maxValue={2}
                    disabled={this.props.disabled}
                    value={value}
                    onChange={this.handleChange as any}
                />
            </div>
        );
    }
}
